/**
 * Plain calendar dates ("YYYY-MM-DD" from the backend: expiries, earnings,
 * session dates). Parsed as a local date, never through `new Date(iso)`,
 * which reads the string as UTC midnight and shows the day before anywhere
 * west of Greenwich. Formatting only: no date maths (the backend sends day
 * counts, policy P4/P5).
 */
export function parsePlainDate(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return null;
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
}

/** "Oct 29" (or with options, e.g. { weekday: 'short' } → "Thu, Oct 29"). */
export function fmtPlainDate(
  iso: string | null | undefined,
  opts: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' },
): string | null {
  const d = parsePlainDate(iso);
  return d ? d.toLocaleDateString('en-US', opts) : null;
}

/** "Oct 2025" - the start of an interim IV-rank window. */
export function fmtMonthYear(iso: string | null | undefined): string | null {
  return fmtPlainDate(iso, { month: 'short', year: 'numeric' });
}
